import { createContext, useContext, useEffect, useState } from "react";
import { getData } from "../Services/api";


const ProfileContext = createContext();

export const ProfileProvider = ({ children }) => {
    const [profile, setProfile] = useState({
        username: "",
        email: "",
        mobile: "",
        profile_image: null,
    })

    const fetchProfile = async () => {
        try {
            const res = await getData('/auth/profile');
            if (res.status) {
                setProfile(res.data || {})
            }
        } catch (error) {
            console.log("fetch profile error", error)
        }
    }

    useEffect(() => {
        fetchProfile();
    }, [])
    return (
        <ProfileContext.Provider value={{ profile, setProfile, fetchProfile }}>
            {children}
        </ProfileContext.Provider>
    )
}

export const useProfile = () => useContext(ProfileContext)